import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { RouteLoadingComponent } from './route-loading.component';



@NgModule({
  declarations: [
    RouteLoadingComponent
  ],
  imports: [
    CommonModule,
    MatProgressBarModule
  ],
  exports: [
    RouteLoadingComponent
  ]
})
export class RouteLoadingModule { }
